export default theme => ({
    tabContentInner: {
        position: 'relative',
        marginBottom: 36,
    },
    tabContentInnerTheme: {
        // ...theme.tabContentInnerTheme,
    }
})